// extracted by mini-css-extract-plugin
export var statItem = "_cf-1";
export var statsRow = "_cf-0";